import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import Notices from "./pages/Notices";
import LanguageHelp from "./pages/LanguageHelp";

let lenis = null;

const SmoothScroll = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    lenis = new Lenis({ lerp: 0.09 });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); lenis = null; };
  }, []);
  useEffect(() => {
    const t = setTimeout(() => {
      const el = hash ? document.querySelector(hash) : null;
      if (el && lenis) lenis.scrollTo(el, { offset: -90 });
      else if (lenis) lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }, hash ? 350 : 0);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <a href="#main-content" className="skip-link">Skip to main content</a>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/client-rights" element={<Notices doc="client-rights" />} />
          <Route path="/privacy-practices" element={<Notices doc="privacy-practices" />} />
          <Route path="/nondiscrimination" element={<Notices doc="nondiscrimination" />} />
          <Route path="/language-help" element={<LanguageHelp />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
